import { analytics, AnalyticsEventName, AnalyticsPropertyKey } from '../analytics/index.js';
import { reportEarlyEcpm } from '../api/requests/economy.requests.js';
import { NetworkManager } from '../network_manager.js';
import { EarlyEcpmQueue, type EarlyEcpmState } from './early_ecpm_queue.js';

const queue = new EarlyEcpmQueue( 'bb_early_ecpm_v1', reportEarlyEcpm, load =>
{
  analytics.track( AnalyticsEventName.AD_APPLOVIN_LOADED_ECPM, {
    [AnalyticsPropertyKey.TIMESTAMP]: load.at,
    [AnalyticsPropertyKey.ADTYPE]: load.format,
    ecpm: load.ecpm,
    load_index: load.index,
    ad_source: load.network,
    revenue_precision: load.precision,
    max_ad_unit: load.ad_unit,
  } );
} );

let online_listener_attached = false;

export function recordAdLoaded( detail: Record<string, unknown> ): void
{
  queue.record( detail );
}

export async function flushEarlyEcpm(): Promise<void>
{
  if ( !online_listener_attached )
  {
    online_listener_attached = true;
    NetworkManager.addOnlineListener( () => { void queue.flush(); } );
  }
  await queue.flush();
}

export function earlyEcpmSnapshot(): Readonly<EarlyEcpmState>
{
  return queue.snapshot();
}

export function resetEarlyEcpm(): void
{
  queue.reset();
}
